(function () {
    "use strict";

    function debounce(func, wait) {
        let timeout;
        return function executedFunction(...args) {
            const later = function () {
                clearTimeout(timeout);
                func(...args);
            };
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
        };
    }

    function initVideoLazyload() {
        const lazyloads = document.querySelectorAll(
            ".video-lazyload:not([data-initialized])"
        );
        lazyloads.forEach(function (lazyload) {
            const videoSrc = lazyload.getAttribute(
                "data-video-src"
            );
            const isAutoplay =
                lazyload.getAttribute("data-autoplay") ===
                "true";
            const poster =
                lazyload.querySelector(".video-poster");
            const playButton = lazyload.querySelector(
                ".play-button-overlay"
            );
            const videoContainer = lazyload.querySelector(
                ".video-container"
            );


            if (!videoSrc) return;

            lazyload.setAttribute("data-initialized", "true");


            function loadVideo() {
                if (videoContainer.querySelector("video"))
                    return;

                lazyload.classList.add("loading");

                const video =
                    document.createElement("video");

                video.src = videoSrc;

                video.preload = "metadata";
                video.style.width = "100%";
                video.style.height = "100%";
                video.style.objectFit = "cover";

                if (isAutoplay) {
                    video.autoplay = true;
                    video.muted = true;
                    video.loop = true;
                    video.controls = false;
                    video.playsInline = true;
                    video.setAttribute(
                        "webkit-playsinline",
                        "true"
                    );
                    video.setAttribute("playsinline", "");
                } else {
                    video.controls = true;
                }

                if (video.fetchPriority !== undefined) {
                    video.fetchPriority = "high";
                }

                video.addEventListener(
                    "loadedmetadata",
                    function () {
                        poster.style.display = "none";
                        videoContainer.style.display =
                            "block";
                        lazyload.classList.remove("loading");
                        lazyload.classList.add("loaded");
                    }
                );

                video.addEventListener(
                    "error",
                    function () {
                        lazyload.classList.remove("loading");
                        lazyload.classList.add("error");
                    }
                );

                video.addEventListener(
                    "canplay",
                    function () {
                        if (isAutoplay) {
                            video.play().catch(function(error) {
                                console.error("Auto-play failed:", error);
                            });
                        }
                    }
                );

                videoContainer.appendChild(video);
                video.load();
            }

            // Setup intersection observer for autoplay videos
            if (
                isAutoplay &&
                "IntersectionObserver" in window
            ) {
                const observer = new IntersectionObserver(
                    function (entries) {
                        entries.forEach(function (entry) {
                            if (entry.isIntersecting) {
                                loadVideo();
                                observer.unobserve(lazyload);
                            }
                        });
                    },
                    {
                        threshold: 0.1, // 降低阈值
                        rootMargin: '50px' // 添加边距，提前触发
                    }
                );

                observer.observe(lazyload);
            } else if (isAutoplay) {
                // Fallback for browsers without intersection observer
                loadVideo();
            }

            // Setup click handler for non-autoplay videos
            if (!isAutoplay && playButton) {
                playButton.addEventListener(
                    "click",
                    function (e) {
                        e.preventDefault();
                        loadVideo();
                    }
                );
            }
        });
    }

    // Initialize on DOM ready
    if (document.readyState === "loading") {
        document.addEventListener(
            "DOMContentLoaded",
            initVideoLazyload
        );
    } else {
        initVideoLazyload();
    }

    // Re-initialize when new content is added (for AJAX/dynamic content)
    const debouncedInit = debounce(initVideoLazyload, 100);

    // Watch for mutations to catch dynamically added video lazyloads
    if ("MutationObserver" in window) {
        const observer = new MutationObserver(
            debouncedInit
        );
        observer.observe(document.body, {
            childList: true,
            subtree: true,
        });
    }
})();